import { render, staticRenderFns } from "./ModalEscapeStudy.vue?vue&type=template&id=944a291c&scoped=true&lang=pug&"
import script from "./ModalEscapeStudy.vue?vue&type=script&lang=ts&"
export * from "./ModalEscapeStudy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "944a291c",
  null
  
)

export default component.exports